import { createContext } from "react";

type SignatureDataContextType = {
  signatureData: string | null;
  setSignatureData: (data: string | null) => void;
};

export const SignatureDataContext =
  createContext<SignatureDataContextType | null>(null);
